konnyScript(function($){
    
  var swiper = new Swiper("#nb2507_swiper_slide1", {
    slidesPerView:'auto',
    slidesPerGroup:1,
    spaceBetween:'2.9%',
    centeredSlides:false,
    observer:true,
    observeParents:true,
    //loop:true,
    pagination:true,
    scrollbar: {
      el: '#nb2507_swiper_slide1 .swiper-scrollbar',
    },
    pagination: {
      el: '#nb2507_swiper_slide1 .swiper-pagination',
    },
    navigation: {
      nextEl: '#nb2507_swiper_slide1 .swiper-button-next',
      prevEl: '#nb2507_swiper_slide1 .swiper-button-prev',
    },
  });
    
  var swiper = new Swiper("#nb2507_swiper_slide2", {
    slidesPerView:'auto',
    slidesPerGroup:1,
    spaceBetween:'2.9%',
    centeredSlides:false,
    observer:true,
    observeParents:true,
    //loop:true,
    pagination:true,
    scrollbar: {
      el: '#nb2507_swiper_slide2 .swiper-scrollbar',
    },
    pagination: {
      el: '#nb2507_swiper_slide2 .swiper-pagination',
    },
    navigation: {
      nextEl: '#nb2507_swiper_slide2 .swiper-button-next',
      prevEl: '#nb2507_swiper_slide2 .swiper-button-prev',
    },
  });
  
});